import React from 'react';
import { PropTypes } from 'prop-types';
import { DialogsProvider, ToastProvider } from '../../providers';
import { withContextProvider } from '../../hoc';
import HeaderWithBreadcrumbs from '../../componentsV2/Headers/HeaderWithBreadcrumbs';
import VisitForm from './VisitForm';

const VisitFormWrapper = ({
  visitId = null, organizationId, siteName, siteId,
}) => {
  const [visitPurpose, setVisitPurpose] = React.useState('');

  const breadcrumbLinks = [
    { href: '/visits', name: 'Visits' },
    visitId && siteId
      ? { href: `/sites/${siteId}/`, name: siteName }
      : { name: siteName || 'New Visit' },
    ...(visitPurpose ? [{ name: visitPurpose }] : []),
  ];

  return (
    <DialogsProvider>
      <div className="mb-12 ml-2.75">
        <header>
          <HeaderWithBreadcrumbs links={breadcrumbLinks} name="visits" label="Visits" size="h-9" />
        </header>
        <VisitForm
          visitId={visitId}
          organizationId={organizationId}
          siteName={siteName}
          siteId={siteId}
          onPurposeChange={setVisitPurpose}
        />
      </div>
    </DialogsProvider>
  );
};

VisitFormWrapper.propTypes = {
  visitId: PropTypes.number,
  organizationId: PropTypes.number.isRequired,
  siteName: PropTypes.string.isRequired,
  siteId: PropTypes.number.isRequired,
};

export default withContextProvider(ToastProvider)(VisitFormWrapper);
